module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_photograph_01-50c5e730773dd3975e71958d64fa3bd3.png";